import * as marietta from '../..';

export default class Dialog {
  viewObj: HTMLElement;

  _draggable: boolean;

  globalCleanUpFunc: Function;

  dialogOffset: marietta.core.Point;

  dialogPosition: marietta.core.Point;

  showHeaderCloseButton: boolean = true;

  targetModule: number;

  callBack: Function;

  hasModal: boolean;

  _prevDialog: Dialog = null;

  public set prevDialog(v: Dialog) {
    this._prevDialog = v;
    if (v) {
      const zIndex = Number(getComputedStyle((v.viewObj)).zIndex);
      this.viewObj.style.zIndex = String(zIndex + 2);
    }
    this.handleModal();
  }

  public get prevDialog(): Dialog {
    return this._prevDialog;
  }

  /**
   * コンストラクタ
   */
  constructor(draggable: boolean, _hasModal: boolean = true) {
    this._draggable = draggable;
    this.hasModal = _hasModal;
  }

  /**
   * ダイアログの作成
   */
  createDialog(dialogID: string, title: string, contents: string, controller?: string) {
    // エレメント初期化
    this.viewObj = document.createElement('div');
    this.viewObj.setAttribute('id', dialogID);
    this.viewObj.classList.add('dialogBox');

    let elHeader: string = '';
    let elBody: string = '';
    let elFooter: string = '';
    const parser = new DOMParser();
    // ヘッダー生成
    elHeader += `<div id='dialogHeader_${dialogID}' class="dialogHeader">\n`;
    // ヘッダーの閉じるボタン
    if (this.showHeaderCloseButton) {
      elHeader += '<div class="dialogClose"><button class="dialogCloseBtn"><i class="icon icon-close4">×</i></button></div>\n';
    }
    elHeader += `<div class="dialogTitle">${title}</div>`;
    elHeader += '</div>';

    // ボディ生成
    elBody += '<div class="dialogBody">\n';
    elBody += contents;
    elBody += '</div>';

    // コントロールバー(フッター)生成
    if (controller) {
      elFooter += '<div class="dialogFooter">\n';
      elFooter += controller;
      elFooter += '</div>';
    }

    this.viewObj.append(parser.parseFromString(elHeader, 'text/html').body.children[0]);
    this.viewObj.append(parser.parseFromString(elBody, 'text/html').body.children[0]);
    if (elFooter) {
      this.viewObj.append(parser.parseFromString(elFooter, 'text/html').body.children[0]);
    }

    // ダイアログ用コンテナに追加
    const container: Element = document.querySelector('#dialogContainer');
    container.appendChild(this.viewObj);

    this.viewObj.style.display = 'block';

    // ダイアログの移動
    if (this._draggable) {
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        document.querySelector(`#dialogHeader_${dialogID}`)
          .addEventListener('touchstart', this.headerMouseDownHandler);
      } else {
        document.querySelector(`#dialogHeader_${dialogID}`)
          .addEventListener('mousedown', this.headerMouseDownHandler);
      }
      (<HTMLElement>document.querySelector(`#dialogHeader_${dialogID}`)).style.cursor = 'move';
    }
    this.dialogOffset = new marietta.core.Point(0, 0);
    this.dialogPosition = new marietta.core.Point(0, 0);

    if (this.showHeaderCloseButton) {
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        // タイトルバーの×ボタン
        this.viewObj.querySelector('.dialogCloseBtn')
          .addEventListener('touchend', this.close, { passive: false });
      } else {
        // タイトルバーの×ボタン
        this.viewObj.querySelector('.dialogCloseBtn')
          .addEventListener('click', this.close);
      }
    }
    this.handleModal();
  }

  /**
   * 閉じるボタンが押された
   */
  close = () => {
    this.closeEvent();
  };

  /**
   * ダイアログを閉じる
   */
  closeEvent() {
    this.viewObj.remove();
    if (this.showHeaderCloseButton) {
      this.viewObj.querySelector('.dialogCloseBtn')
        .removeEventListener('click', this.close);
    }

    // コールバックのお掃除関数
    if (this.globalCleanUpFunc) this.globalCleanUpFunc();

    if (this.prevDialog) {
      marietta.webcad.WebCADGlobal.currentDialog = this.prevDialog;
      if (marietta.webcad.WebCADGlobal.currentDialog.hasModal) marietta.webcad.WebCADGlobal.currentDialog.handleModal();
    }

    // 3Dの場合
    if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '3D') {
      if (!this.prevDialog) {
        marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
      }
    }

    // モーダルのデザインを元に戻す
    document.getElementById('modalBg').style.backgroundColor = '#000';
    document.getElementById('modalBg').style.opacity = '.6';
    document.getElementById('modalBg').style.pointerEvents = 'auto';
  }

  /**
   * 内容の追加
   */
  // eslint-disable-next-line class-methods-use-this
  buildContent() {
  }

  // overrideして使用.

  /**
   * ダイアログを中心へ
   */
  public centerDialog() {
    // window-heightに対する、ダイアログ高さ調整
    const h1: number = this.viewObj.querySelector('.dialogBody')
      .getBoundingClientRect().height;

    const dialogFooter = this.viewObj.querySelector('.dialogFooter');

    const h2: number = (dialogFooter) ? this.viewObj.querySelector('.dialogFooter')
      .getBoundingClientRect().height : 0;
    if (window.innerHeight <= (h1 + h2 + 120)) {
      (this.viewObj.querySelector('.dialogBody') as HTMLElement).style.height = `${window.innerHeight - h2 - 120}px`;
    }

    // ダイアログの幅調整
    let maxW: number = 0;
    for (let i: number = 0; i < this.viewObj.children.length; i += 1) {
      const w: number = this.viewObj.children[i].getBoundingClientRect().width;
      if (maxW < w) {
        maxW = Math.ceil(w);
      }
      (this.viewObj.children[i] as HTMLElement).style.display = 'block';
    }
    this.viewObj.style.width = `${maxW}px`;

    // ダイアログの高さ調整
    let boxHeight: number = 0;
    for (let i: number = 0; i < this.viewObj.children.length; i += 1) {
      boxHeight += this.viewObj.children[i].getBoundingClientRect().height;
    }
    this.viewObj.style.height = `${boxHeight}px`;
  }

  /**
   * ダイアログの移動開始
   */
  headerMouseDownHandler = (e: any) => {
    e.preventDefault();
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      // パネルのクリック位置格納
      this.dialogOffset.x = (<TouchEvent>e).changedTouches[0].pageX;
      this.dialogOffset.y = (<TouchEvent>e).changedTouches[0].pageY;
      document.addEventListener('touchmove', this.headerMouseMoveHandler, { passive: false });
      document.addEventListener('touchend', this.headerMouseUpHandler, { passive: false });
    } else {
      // パネルのクリック位置格納
      this.dialogOffset.x = e.clientX;
      this.dialogOffset.y = e.clientY;
      document.addEventListener('mousemove', this.headerMouseMoveHandler);
      document.addEventListener('mouseup', this.headerMouseUpHandler);
    }
  };

  headerMouseMoveHandler = (e: MouseEvent | TouchEvent) => {
    e.preventDefault();
    let posX: number;
    let posY: number;
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      posX = (<TouchEvent>e).changedTouches[0].pageX - this.dialogOffset.x + this.dialogPosition.x;
      posY = (<TouchEvent>e).changedTouches[0].pageY - this.dialogOffset.y + this.dialogPosition.y;
    } else {
      posX = (<MouseEvent>e).clientX - this.dialogOffset.x + this.dialogPosition.x;
      posY = (<MouseEvent>e).clientY - this.dialogOffset.y + this.dialogPosition.y;
    }
    const cssTransform = `translate(${posX}px,${posY}px)`;
    this.viewObj.style.transform = cssTransform;
  };

  headerMouseUpHandler = (e: MouseEvent | TouchEvent) => {
    e.preventDefault();
    // transformで移動したパネルの配置格納
    const cssVal: string = new WebKitCSSMatrix(this.viewObj.style.transform).toString();
    if (cssVal.indexOf('matrix') > -1) {
      const cssValTemp: string[] = cssVal.split(', ');
      this.dialogPosition.x = parseInt(cssValTemp[4], 10);
      this.dialogPosition.y = parseInt(cssValTemp[5].split(')')[0], 10);
    }
    if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      document.removeEventListener('touchmove', this.headerMouseMoveHandler);
      document.removeEventListener('touchend', this.headerMouseUpHandler);
    } else {
      document.removeEventListener('mousemove', this.headerMouseMoveHandler);
      document.removeEventListener('mouseup', this.headerMouseUpHandler);
    }
  };

  handleModal = () => {
    if (this.hasModal) {
      document.getElementById('modalBg').style.display = 'block';
      const zIndex = Number(getComputedStyle(this.viewObj).zIndex);
      document.getElementById('modalBg').style.zIndex = String(zIndex - 1);
    }
  };
}
